export default __webpack_public_path__ + "static/media/ARM_frame_arm_4.dba53f70.png";